/* ============================================================
 * MAISON TO SPORT — CRO behavior layer (v1)
 * - Sticky ATC on mobile PDP
 * - 3+1 OFFERT progress bar on cart pages
 * - Hero image LCP boost (force first hero img eager + fetchpriority)
 * - Mark body for mobile PDP padding
 * Added: 2026-05-11 — additive, non-breaking
 * ============================================================ */
(function() {
  'use strict';

  // -------- 1. Hero LCP fix: force first banner/slideshow image to eager + high priority --------
  function fixHeroLCP() {
    var candidates = [
      'main#MainContent img:first-of-type',
      '[data-section-type="slideshow"] .swiper-slide:first-child img',
      '[data-section-type="slideshow-with-product"] .swiper-slide:first-child img',
      '.shopify-section:first-of-type img',
    ];
    var imgs = [];
    candidates.forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(img) { if (imgs.indexOf(img) === -1) imgs.push(img); });
    });
    if (imgs.length) {
      var hero = imgs[0];
      hero.setAttribute('loading', 'eager');
      hero.setAttribute('fetchpriority', 'high');
      hero.setAttribute('decoding', 'async');
    }
  }

  // -------- 2. Sticky ATC on mobile PDP --------
  function setupStickyATC() {
    if (!document.body.classList.contains('product-template') && !document.body.classList.contains('template-product')) return;
    if (window.innerWidth > 768) return;
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    var atcBtn = form.querySelector('[type="submit"], button.product-form__submit, button[name="add"]');
    if (!atcBtn) return;
    document.body.classList.add('mts-pdp-mobile');

    // Read price from common locations
    var priceEl = document.querySelector('.product__price .price-item--regular, .product__price [data-product-price], .price__regular .price-item, .product-price');
    var comparePriceEl = document.querySelector('.product__price .price-item--sale, .price__sale .price-item--regular, .price__compare, [data-compare-price]');
    var priceText = priceEl ? priceEl.textContent.trim() : '';
    var compareText = comparePriceEl ? comparePriceEl.textContent.trim() : '';

    var bar = document.createElement('div');
    bar.className = 'mts-sticky-atc mts-cro-scope';
    bar.innerHTML = '\
      <div class="mts-sa-price">' + (priceText || 'Voir le prix') + (compareText && compareText !== priceText ? '<small>' + compareText + '</small>' : '') + '</div>\
      <button type="button" class="mts-sa-btn">Ajouter au panier</button>';
    document.body.appendChild(bar);
    bar.querySelector('.mts-sa-btn').addEventListener('click', function() {
      atcBtn.click();
    });

    // Show sticky bar when original ATC is scrolled out of view
    function check() {
      var r = atcBtn.getBoundingClientRect();
      var visible = r.top < window.innerHeight && r.bottom > 0;
      bar.classList.toggle('show', !visible);
    }
    var t;
    window.addEventListener('scroll', function() {
      clearTimeout(t); t = setTimeout(check, 50);
    }, { passive: true });
    check();
  }

  // -------- 3. 3+1 OFFERT progress bar on cart --------
  function setupBundleProgress() {
    if (!document.body.classList.contains('template-cart') && location.pathname !== '/cart') return;
    // Count jersey items (assume each line is 1 unit but use quantity)
    function countItems() {
      // Best-effort: target known item rows
      var rows = document.querySelectorAll('[data-cart-item], .cart-item, .cart__row, [data-line-item]');
      if (!rows.length) return null;
      var total = 0;
      rows.forEach(function(r) {
        var qty = r.querySelector('input[name*="quantity"], [data-qty], .qty');
        var n = qty ? parseInt(qty.value || qty.textContent, 10) : 1;
        if (!isNaN(n)) total += n;
      });
      return total;
    }
    function render() {
      var n = countItems();
      if (n === null) return;
      // 3+1 logic: every 4 items gets 1 free. Compute next milestone.
      var nextThreshold = Math.ceil((n + 1) / 4) * 4;
      var remaining = nextThreshold - n;
      var bar = document.getElementById('mts-bundle-progress');
      if (!bar) {
        bar = document.createElement('div');
        bar.id = 'mts-bundle-progress';
        bar.className = 'mts-bundle-progress mts-cro-scope';
        var anchor = document.querySelector('main#MainContent, [data-cart]') || document.body.firstElementChild;
        anchor.insertBefore(bar, anchor.firstChild);
      }
      var pct = Math.min(100, Math.round((n % 4) / 4 * 100));
      var text;
      if (n === 0) {
        text = '🎁 Ajoute 3 maillots et reçois le 4ème OFFERT';
        pct = 0;
      } else if (n % 4 === 0 && n > 0) {
        text = '🎉 Bravo ! Tu profites de l\'offre 3+1 — ' + (n / 4) + ' maillot(s) offert(s)';
        pct = 100;
      } else if (remaining === 1) {
        text = '🔥 Plus que 1 maillot pour avoir le ' + nextThreshold + 'ème OFFERT !';
      } else {
        text = '🎁 Encore ' + remaining + ' maillots pour avoir le ' + nextThreshold + 'ème OFFERT';
      }
      bar.innerHTML = '\
        <div class="mts-bp-text">' + text + '</div>\
        <div class="mts-bp-bar"><div class="mts-bp-fill" style="width:' + pct + '%"></div></div>';
    }
    render();
    // Update on cart updates (rough listener for ajax updates)
    document.addEventListener('cart:updated', render);
    var obs = new MutationObserver(function() { render(); });
    var mainEl = document.querySelector('main#MainContent');
    if (mainEl) obs.observe(mainEl, { childList: true, subtree: true });
  }

  // -------- 4. Init --------
  function init() {
    try { fixHeroLCP(); } catch (e) { console.warn('[mts-cro] hero', e); }
    try { setupStickyATC(); } catch (e) { console.warn('[mts-cro] atc', e); }
    try { setupBundleProgress(); } catch (e) { console.warn('[mts-cro] bundle', e); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
